module.exports = __webpack_public_path__ + "static/img/1_g_tick.ae9d13b6.png";